// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__VDsz7","copyright":"Footer_copyright__1CA_Z"};